import React from 'react'
import Fade from 'react-reveal/Fade'
import parse from 'html-react-parser'

const PageHeader = ({ title, h1, fullWidth }) => {
  return (
    <>
      <section className={`page-header${fullWidth ? ' page-header--full' : ''}`}>
        <Fade distance='40px' bottom>
          <div className='page-header__inner'>
            { h1 ? <h1>{parse(title)}</h1> : <h2>{parse(title)}</h2> }
          </div>
        </Fade>
      </section>
    </>
  )
}

export default PageHeader